<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2 v-if="isOn">{{ $t("navigations.soa change visualization") }}</h2>
      <h2 v-if="!isOn">Study Version Comparison</h2>
    </div>
    <div class="col-md-2 d-flex justify-content-end gap-2">
      <a
        href="#"
        class="view-btn"
        :class="{ 'is-active': isOn }"
        aria-label="Graph view"
        :aria-pressed="isOn ? 'true' : 'false'"
        @click.prevent="isOn = true"
      >
        <img :src="require('@/assets/img/icons/graph_view.png')" alt="Graph view" />
      </a>

      <a
        href="#"
        class="view-btn"
        :class="{ 'is-active': !isOn }"
        aria-label="Tree view"
        :aria-pressed="!isOn ? 'true' : 'false'"
        @click.prevent="isOn = false"
      >
        <img :src="require('@/assets/img/icons/tree_view.png')" alt="Tree view" />
      </a>
    </div>
  </div>
<soadiffgraph v-if="isOn"/>
<soadifftree v-if="!isOn"/>
</template>

<script src="./studydiffviewer.js"></script>

<style scoped>
@import "../../assets/css/style.css";

.view-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  border: 2px solid #9e9e9e;
  border-radius: 6px;
  cursor: pointer;
  transition: border-color .15s ease, background-color .15s ease, box-shadow .15s ease, transform .05s ease;
}

.view-btn img {
  width: 20px;
  height: 20px;
  display: block;
}

.view-btn:hover {                /* hover feedback */
  border-color: #00c3ff;
}

.view-btn:active {               /* pressed feedback */
  transform: translateY(1px);
  background-color: rgba(116, 220, 255, .2);
  border-color: #74dcff;
}

/* persistent selected state */
.view-btn.is-active {
  background-color: #e7f6ff;
  border-color: #00c3ff;
  box-shadow: 0 0 0 2px rgba(0, 195, 255, .2) inset;
}

/* keyboard focus (accessibility) */
.view-btn:focus-visible {
  outline: 2px solid #00c3ff;
  outline-offset: 2px;
}

</style>
